import React, { useState } from 'react';
import { Search, SlidersHorizontal, X } from 'lucide-react';
import { Store } from '../../types';
import { StoreCard } from '../StoreCard';
import { STORES } from '../../data/mockData';
import { Input } from '../ui/Input';
interface ExploreScreenProps {
  onStoreClick: (store: Store) => void;
  onPeekInside?: (store: Store) => void;
  onImHere?: (store: Store) => void;
}
export function ExploreScreen({
  onStoreClick,
  onPeekInside,
  onImHere
}: ExploreScreenProps) {
  const [search, setSearch] = useState('');
  const [activeFilter, setActiveFilter] = useState('All');
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const filters = ['All', 'Gathering Spots', 'Coffee', 'Food', 'Books', 'Retail', 'Bar'];
  const filteredStores = STORES.filter(store => {
    const matchesSearch = store.name.toLowerCase().includes(search.toLowerCase());
    const matchesFilter = activeFilter === 'All' || (activeFilter === 'Gathering Spots' ? store.hasGatheringSpot : store.tags.some(tag => tag.includes(activeFilter)));
    return matchesSearch && matchesFilter;
  });
  return <div className="pb-24 pt-6 px-4 h-full flex flex-col animate-in fade-in duration-500" data-id="element-736">
      <h1 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-737">Explore Nearby</h1>

      {/* Search & Filter */}
      <div className="sticky top-0 bg-white z-10 pb-4 space-y-4" data-id="element-738">
        <div className="flex gap-3" data-id="element-739">
          <Input placeholder="Search stores..." icon={<Search size={18} data-id="element-741" />} value={search} onChange={e => setSearch(e.target.value)} className="bg-gray-50 border-none" data-id="element-740" />
          <button onClick={() => setShowFilterPanel(!showFilterPanel)} className={`p-3 rounded-xl transition-colors ${showFilterPanel ? 'bg-purple-600 text-white' : 'bg-gray-50 text-gray-600 hover:bg-gray-100'}`} data-id="element-742">
            <SlidersHorizontal size={20} data-id="element-743" />
          </button>
        </div>

        {/* Filter Panel */}
        {showFilterPanel && <div className="bg-gray-50 rounded-2xl p-4 animate-in fade-in slide-in-from-top-2 duration-300" data-id="element-744">
            <div className="flex items-center justify-between mb-3" data-id="element-745">
              <h3 className="font-bold text-gray-900" data-id="element-746">Filter by Category</h3>
              <button onClick={() => setShowFilterPanel(false)} className="text-gray-400 hover:text-gray-600" data-id="element-747">
                <X size={20} data-id="element-748" />
              </button>
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-749">
              {filters.map(filter => <button key={filter} onClick={() => {
            setActiveFilter(filter);
            setShowFilterPanel(false);
          }} className={`
                    px-4 py-2 rounded-full text-sm font-semibold transition-colors
                    ${activeFilter === filter ? 'bg-purple-600 text-white shadow-md shadow-purple-600/20' : 'bg-white text-gray-600 hover:bg-gray-100'}
                  `} data-id="element-750">
                  {filter}
                </button>)}
            </div>
          </div>}

        {/* Active Filter Chip */}
        {activeFilter !== 'All' && <div className="flex items-center gap-2" data-id="element-751">
            <span className="text-sm text-gray-600" data-id="element-752">Active filter:</span>
            <button onClick={() => setActiveFilter('All')} className="inline-flex items-center gap-2 px-3 py-1.5 bg-purple-100 text-purple-700 rounded-full text-sm font-semibold hover:bg-purple-200 transition-colors" data-id="element-753">
              {activeFilter}
              <X size={14} data-id="element-754" />
            </button>
          </div>}
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 gap-6 mt-2" data-id="element-755">
        {filteredStores.map(store => <StoreCard key={store.id} store={store} onClick={() => onStoreClick(store)} showCheckIn onPeekInside={e => {
        e.stopPropagation();
        onPeekInside?.(store);
      }} onImHere={e => {
        e.stopPropagation();
        onImHere?.(store);
      }} data-id="element-756" />)}
      </div>
    </div>;
}